import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getCategoryLimit } from '@common/utils/widgetConfig';
import {
  getPieChartLegendConfig,
  getPieChartTooltipConfig,
  getPieChartLabelConfig,
  getPieChartLabelLineConfig,
  getPieChartLabelLayoutConfig,
  getPieChartEmphasisConfig,
} from '@common/utils/pieChartConfig';
import ChartWidgetContainer from '@common/components/ChartWidgetContainer';

function PieChartWidget({ widget }) {
  const { t } = useTranslation();
  const { data, config } = widget;

  const otherLabel = t('dashboard.widgets.other');

  const option = useMemo(() => {
    if (!data || !Array.isArray(data)) return null;

    const CATEGORY_LIMIT = getCategoryLimit(config);
    let processedData = data;

    if (CATEGORY_LIMIT && data.length > CATEGORY_LIMIT) {
      const sortedData = [...data].sort((a, b) => b.value - a.value);
      const topItems = sortedData.slice(0, CATEGORY_LIMIT);
      const otherItems = sortedData.slice(CATEGORY_LIMIT);
      const otherValue = otherItems.reduce((sum, item) => sum + item.value, 0);

      processedData = otherValue > 0
        ? [...topItems, { name: otherLabel, value: otherValue }]
        : topItems;
    }

    return {
      tooltip: getPieChartTooltipConfig(),
      legend: getPieChartLegendConfig(),
      series: [
        {
          name: widget.title,
          type: 'pie',
          radius: '50%',
          center: ['60%', '50%'],
          data: processedData.map((item) => ({
            value: item.value,
            name: item.name,
            itemStyle: {
              color: item.color || undefined,
            },
          })),
          emphasis: getPieChartEmphasisConfig(),
          label: getPieChartLabelConfig(),
          labelLine: getPieChartLabelLineConfig(),
          labelLayout: getPieChartLabelLayoutConfig(),
        },
      ],
    };
  }, [data, config, widget.title, otherLabel]);

  return <ChartWidgetContainer widget={widget} option={option} />;
}

export default PieChartWidget;
